import React, { Suspense } from 'react';
import { Redirect, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from '../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit';
import ObjectsPage from '../../../../_metronic/layout/components/basePage/pages/ObjectsPage';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import {
  formFields,
  otherFields,
  initObject,
  ObjectEditSchema,
  columns,
  prepareFilter,
  filterFields,
  filterInitialValues,
} from './AnswerUtils';




const AnswerPage = () => {

  const { currentState } = useSelector(
    (state) => ({ currentState: state.answers }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find(q => q.url == "/form")) {
    const temp = menuList.find(q => q.url == "/form")
    isFullAccess = temp.isFullAccess;
  }

  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          {/* {
          <Redirect
            // exact={true}
            from="/form/formTypes"
            to="/form/answers"
          />
        }

        {
          <Redirect
            // exact={true}
            from="/form/forms"
            to="/form/answers"
          />
        }

        {
          <Redirect
            // exact={true}
            from="/form/answerQuestions"
            to="/form/answers"
          />
        }

{
          <Redirect
            // exact={true}
            from="/form/questions"
            to="/form/answers"
          />
        } */}

          <ContentRoute path="/form/answers/new"
            render={props =>
              <ObjectEdit {...props} isFullAccess={isFullAccess} basePath="/form/answers" api="api/Answer" currentState={currentState} initObject={initObject}
                formFields={formFields} otherFields={otherFields} ObjectEditSchema={ObjectEditSchema} prepareFilter={prepareFilter} />}
          />

          <ContentRoute
            path="/form/answers/:id/edit"
            render={props =>
              <ObjectEdit {...props} isFullAccess={isFullAccess} basePath="/form/answers" api="api/Answer" currentState={currentState} initObject={initObject}
                formFields={formFields} otherFields={otherFields} ObjectEditSchema={ObjectEditSchema} prepareFilter={prepareFilter} />}
          />

          <ContentRoute
            path="/form/answers"
            render={props => <ObjectsPage isFullAccess={isFullAccess} basePath="/form/answers" api="api/Answer" currentState={currentState}
              columns={columns} prepareFilter={prepareFilter} filterFields={filterFields} filterInitialValues={filterInitialValues} />}
          />

        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>
  )
}

export default AnswerPage



